export default "__VITE_ASSET__DCSfoC6R__"